import { e as extend } from './085c42f3.mjs';
import { s as serialize$1, d as deserialize$1 } from './26bb3b6f.mjs';

function serialize(obj) {
  if (obj && typeof obj === "object") {
    return `#${serialize$1(obj)}`;
  }
  return void 0;
}
function deserialize(...args) {
  const fragment = args[0];
  let coerce = args[1];
  if (typeof fragment === "boolean" && typeof coerce === "undefined") {
    coerce = fragment;
  } else {
    coerce = typeof coerce === "boolean" ? coerce : true;
  }
  if (typeof fragment === "string") {
    if (fragment.indexOf("#") > -1) {
      return deserialize$1(fragment.split("#")[1], coerce);
    }
    return {};
  }
  if (!window.location.hash) {
    return {};
  }
  return deserialize$1(window.location.hash.substring(1), coerce);
}
function set(fragment) {
  if (typeof fragment === "string") {
    window.location.hash = fragment;
  }
}
function get(param, url) {
  if (typeof param === "string") {
    const deserialized = !!url && url.indexOf("#") > -1 ? deserialize(`#${url.split("#")[1]}`) : deserialize(window.location.hash);
    return Object.prototype.hasOwnProperty.call(deserialized, param) ? deserialized[param] : void 0;
  }
  if (!param) {
    return window.location.hash === "#" ? "" : window.location.hash;
  }
  return void 0;
}
function remove(param, url) {
  if (typeof param === "string" && !!get(param, url)) {
    let deserialized;
    if (typeof url === "string") {
      if (url.indexOf("#") > 1) {
        const splitted = url.split("#");
        deserialized = deserialize(`#${splitted[1]}`);
        delete deserialized[param];
        const serialized = serialize(deserialized);
        return splitted[0] + (serialized.length > 1 ? serialized : "");
      }
      return false;
    }
    deserialized = deserialize(window.location.hash);
    delete deserialized[param];
    set(serialize(deserialized));
    return true;
  }
  return false;
}
function push(fragment, url) {
  const fragm = typeof fragment === "object" ? serialize(fragment) : fragment;
  if (typeof fragm === "string") {
    const target = deserialize$1(fragm.replace("#", ""), false);
    let source;
    let merged;
    let splitted;
    if (typeof url === "string") {
      if (url.indexOf("#") > 1) {
        splitted = url.split("#");
        source = deserialize$1(splitted[1], false);
        merged = serialize(extend(source, target));
        return splitted[0] + merged;
      }
      return url + fragm;
    }
    source = deserialize$1(window.location.hash.substring(1), false);
    merged = serialize(extend(source, target));
    set(merged);
    return merged;
  }
  return void 0;
}

var index = /*         */Object.freeze({
  __proto__: null,
  deserialize: deserialize,
  get: get,
  push: push,
  remove: remove,
  serialize: serialize,
  set: set
});

export { set as a, deserialize as d, get as g, index as i, push as p, remove as r, serialize as s };
/*                                 */
